/* unplugin-vue-components disabled */import { render } from "./BulkUpdate.vue?vue&type=template&id=fe964304"
import script from "./BulkUpdate.vue?vue&type=script&lang=js"
export * from "./BulkUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/myfunnl/isspadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__